
import React from 'react';
import { sponsors } from '../../../mocks/sponsors';

export const SponsorsSection: React.FC = () => {
  const platinumSponsors = sponsors.filter(s => s.tier === 'Platinum');
  const goldSponsors = sponsors.filter(s => s.tier === 'Gold');
  const silverSponsors = sponsors.filter(s => s.tier === 'Silver');
  const bronzeSponsors = sponsors.filter(s => s.tier === 'Bronze');

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Sponsors</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            We are grateful to our community partners who support our mission to preserve and promote Persian culture
          </p>
        </div>

        {/* Platinum Sponsors */}
        {platinumSponsors.length > 0 && (
          <div className="mb-12">
            <h3 className="text-2xl font-bold text-center text-gray-800 mb-8">Platinum Sponsors</h3>
            <div className="flex justify-center">
              <div className="grid grid-cols-1 gap-8">
                {platinumSponsors.map((sponsor) => (
                  <div key={sponsor.id} className="flex justify-center">
                    <img
                      src={sponsor.logo}
                      alt={sponsor.name}
                      className="h-20 w-auto object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Gold Sponsors */}
        {goldSponsors.length > 0 && (
          <div className="mb-12">
            <h3 className="text-xl font-bold text-center text-gray-800 mb-6">Gold Sponsors</h3>
            <div className="flex justify-center">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {goldSponsors.map((sponsor) => (
                  <div key={sponsor.id} className="flex justify-center">
                    <img
                      src={sponsor.logo}
                      alt={sponsor.name}
                      className="h-16 w-auto object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Silver Sponsors */}
        {silverSponsors.length > 0 && (
          <div className="mb-12">
            <h3 className="text-lg font-bold text-center text-gray-800 mb-6">Silver Sponsors</h3>
            <div className="flex justify-center">
              <div className="grid grid-cols-2 md:grid-cols-2 gap-6">
                {silverSponsors.map((sponsor) => (
                  <div key={sponsor.id} className="flex justify-center">
                    <img
                      src={sponsor.logo}
                      alt={sponsor.name}
                      className="h-12 w-auto object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Bronze Sponsors */}
        {bronzeSponsors.length > 0 && (
          <div>
            <h3 className="text-lg font-bold text-center text-gray-800 mb-6">Bronze Sponsors</h3>
            <div className="flex justify-center">
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {bronzeSponsors.map((sponsor) => (
                  <div key={sponsor.id} className="flex justify-center">
                    <img
                      src={sponsor.logo}
                      alt={sponsor.name}
                      className="h-10 w-auto object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            Interested in becoming a sponsor?
          </p>
          <a
            href="mailto:info@atlantapcc.com"
            className="inline-flex items-center text-red-600 hover:text-red-700 font-medium"
          >
            Contact us to learn more
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
};
